import React from 'react'
import {PainelNoticias} from '../components/Noticias/PainelNoticias'


export const Noticias = () => {
  return (
    <>
      <PainelNoticias />
    </>
  )
}
